import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store"; 
import { SupportedLocale } from "../enums/componentEnums";


interface LanguageState {
  language: SupportedLocale;
}

const initialState: LanguageState = {
  language: SupportedLocale.EN_US,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<SupportedLocale>) {
      state.language = action.payload;
    },
  },
});

// Export actions
export const { setLanguage } = languageSlice.actions;

// Selector
export const selectLanguage = (state: RootState) => state.language.language;

export default languageSlice.reducer;
